import { gql } from "@apollo/client";

export const UpdateGridItem = gql`
    mutation UpdateGridItem ($id: ID!, $input: GridItemUpdateAttributesInput!){
        updateGridItem(id: $id, input: $input) {
            id
            visible
            config {
                id
                x
                y
                w
                h
            }
        }
    }
`;
